import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import { initialCookieValues, clearConsentCookie } from '../cookies';
import RefreshIcon from '@material-ui/icons/Refresh';
import { tcfApi } from '../iab-tcf';

function ResetButton({ setActiveScreen, setSelectedCookies }) {
  const resetAll = () => {
    clearConsentCookie();
    tcfApi.resetAll();
    setActiveScreen('start');
    setSelectedCookies({ ...initialCookieValues });
  };

  return (
    <Button variant="outlined" title="Refresh" data-test-id="consent-reset" onClick={resetAll}>
      <RefreshIcon />
    </Button>
  );
}

ResetButton.propTypes = {
  setActiveScreen: PropTypes.func.isRequired,
  setSelectedCookies: PropTypes.func.isRequired,
};

export default ResetButton;
